var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontEndDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3D5B54;}\r\n\t.st1{fill:#324C4A;}\r\n\t.st2{fill:#E9F1FF;}\r\n\t.st3{fill:#203836;}\r\n\t.st4{fill:#D7E4F7;}\r\n\t.st5{fill:#BED2EE;}\r\n\t.st6{fill:#99E6FC;}\r\n\t.st7{fill:#49D690;}\r\n\t.st8{fill:#FED44C;}\r\n\t.st9{fill:#FD4754;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,24.6H2V5c0-0.5,0.4-1,1-1H27l1.4,0c0.5,0,1,0.4,1,1V24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,4h-2c0.5,0,1,0.4,1,1v19h2V5C30,4.4,29.6,4,29,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.4,21.4H4.6L4,16V8l0.6-1.4h22.7L28,8v8L27.4,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.4,28L29,28H1c-0.5,0-1-0.4-1-1v-2.6C0,24.2,0.2,24,0.5,24H10l6,0.6l6-0.6h8l1.4,0.6V27 C31.4,27.6,30.9,28,30.4,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,24v3c0,0.5-0.4,1-1,1h2c0.5,0,1-0.4,1-1v-2.6c0-0.2-0.2-0.5-0.5-0.5H30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21,24.6l-1-0.6H10l0.7,1.5c0.2,0.3,0.5,0.5,0.9,0.5h6.9l1.3,0c0.4,0,0.7-0.2,0.9-0.5L21,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.1,24l-0.7,1.5c-0.2,0.3-0.5,0.5-0.9,0.5h1.9c0.4,0,0.7-0.2,0.9-0.5L22,24H20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20,22l0.6-3.5L20,16h-8l-0.6,2.5L12,22H20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28,21.5V16h-8v6h7.5C27.8,22,28,21.8,28,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M12,22v-6H4v5.5C4,21.8,4.2,22,4.5,22H12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M4,8h24V6.5C28,6.2,27.8,6,27.5,6H4.5C4.2,6,4,6.2,4,6.5V8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M13,14.5c-0.1,0-0.2,0-0.3-0.1l-2-2c-0.1-0.1-0.1-0.2-0.1-0.3s0.1-0.3,0.1-0.3l2-2c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7L11.7,12l1.7,1.7c0.2,0.2,0.2,0.5,0,0.7C13.2,14.4,13.1,14.5,13,14.5L13,14.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M15,14.5c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l2-4c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-2,4C15.3,14.4,15.2,14.5,15,14.5L15,14.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19,14.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l1.7-1.7l-1.7-1.7c-0.2-0.2-0.2-0.5,0-0.7 c0.2-0.2,0.5-0.2,0.7,0l2,2c0.2,0.2,0.2,0.5,0,0.7l-2,2C19.2,14.4,19.1,14.5,19,14.5L19,14.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10,18.5H6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5S10.3,18.5,10,18.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9,20.5H7c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S9.3,20.5,9,20.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18,18.5h-4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5S18.3,18.5,18,18.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17,20.5h-2c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S17.3,20.5,17,20.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26,18.5h-4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5S26.3,18.5,26,18.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25,20.5h-2c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S25.3,20.5,25,20.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontEndDevelopment);
export default __webpack_public_path__ + "static/media/front-end-development.714336cb9ba6a4c17c825907d117c9b8.svg";
export { ForwardRef as ReactComponent };